import React from 'react';
import SideBar from './SideBar/SideBar.js';
import HomeBlock from './HomeBlock/HomeBlock.js';
import ModelDropdown from './ModelDropdown/ModelDropdown.js';
import ChatComposer from './ChatComposer/ChatComposer.js';
import Portal from './Portal.js';
import Error from './Error/Error.js';
import styles from './Pages.module.css';

function HomePage() {
  return (
    <div className={styles.layout}>
      <Portal >
        <Error />
      </Portal>
      <SideBar/>
      <ModelDropdown />
      <div className={styles.content}>
        <div className={styles.main}>
          <HomeBlock />
          <ChatComposer />
        </div>
      </div>
    </div>
  );
}

export default HomePage;